module.exports = __webpack_public_path__ + "img/dash-log.618f45b1.png";